import moment from 'moment';
import { LABEL } from './FiltersContainer.constants';

const {
  buttonFilterTemplate,
  buttonRoomsTemplate,
  headerFilter,
  propertyTypeTitle,
  propertyTypesDescription,
  distanceTitle,
  distanceDescriptionTemplate,
  priceRangeTitle,
  priceRangeDescription,
  priceRangeNumberFormat,
  amenitiesTitle,
  amenitiesDescription,
  seeMoreLabel,
  instantBookTitle,
  instantBookDescription,
  clearButtonLabel,
  updateButtonLabel,
  headerRooms,
  roomsDescription,
  roomsButtonLabel,
  roomsDisclaimerMobile,
  roomsDisclaimerDesktop,
  buttonDatesTemplate,
  headerDates,
  datesDisclaimer,
  startDate,
  endDate,
  dates,
  apply,
  reset,
  rooms
} = LABEL;

export const labels = {
  [buttonFilterTemplate]: 'More Filters ({numFilters})',
  [buttonRoomsTemplate]: '{numRooms} Rooms',
  [buttonDatesTemplate]: '{labelStartDate} - {labelEndDate}',
  // Dates
  [startDate]: 'Start Date',
  [endDate]: 'End Date',
  [dates]: 'Dates',
  [apply]: 'Apply',
  [reset]: 'Reset',
  [headerDates]: 'Select Dates',
  [datesDisclaimer]: 'Note: Individual crew dates can be selected when completing the booking',
  // Rooms
  [rooms]: 'Rooms',
  [headerRooms]: 'Select Rooms',
  [roomsDescription]: 'Total number of rooms',
  [roomsButtonLabel]: 'Update Results',
  [roomsDisclaimerMobile]: 'Note: The number of rooms can be changed up to the first date of your stay',
  [roomsDisclaimerDesktop]: '* The number of rooms can be changed up to the first date of your stay',
  // Filters
  [headerFilter]: 'Select Filters',
  [propertyTypeTitle]: 'Property Type',
  [propertyTypesDescription]: 'Select a property type',
  [distanceTitle]: 'Distance',
  [distanceDescriptionTemplate]: 'Within {distance}',
  [priceRangeTitle]: 'Price Range',
  [priceRangeDescription]: '(Per room, per night)',
  // eslint-disable-next-line no-template-curly-in-string
  [priceRangeNumberFormat]: '${price}',
  [amenitiesTitle]: 'Amenities',
  [amenitiesDescription]: 'Select all that apply',
  [seeMoreLabel]: 'See More +',
  [instantBookTitle]: 'Instant Book',
  [instantBookDescription]: 'Book now, no wait.',
  [clearButtonLabel]: 'Clear',
  [updateButtonLabel]: 'Update Map'
};

export const getLabel = (propsLabels, key) => propsLabels[key] || labels[key];

export const parseTemplate = (template, props, ignoreList) =>
  template.replace(/{[a-z0-9]+}/gi, match => {
    const m = match.substring(1, match.length - 1);
    if (ignoreList && Array.isArray(ignoreList) && ignoreList.indexOf(m) >= 0) {
      return match;
    }
    return props[m];
  });

export const defaultProps = {
  // Shared
  labels,
  selectedOption: undefined,
  showPanel: false,
  inset: 20,
  showBackdrop: false,
  onMobilePanelClose: () => {},
  onPanelButtonClick: () => {},
  onBackdropClick: () => {},

  // Dates
  labelStartDate: moment()
    .utc()
    .format('MMM DD'),
  labelEndDate: moment()
    .utc()
    .add(1, 'days')
    .format('MMM DD'),
  startDate: undefined,
  endDate: undefined,
  onDatesChangeHook: () => {},
  onUpdateDatesButtonClick: () => {},
  onResetButtonClick: () => {},
  onApplyButtonClick: () => {},

  // Rooms
  numRooms: 0,
  numRoomsLabel: 0,
  roomsInputProps: {
    step: 1,
    min: 0,
    max: 999
  },
  onRoomButtonClick: () => {},
  onRoomsValueChange: () => {},

  // Filters
  numFilters: 0,
  propertyTypes: undefined,
  distance: 0,
  distanceUnitBefore: undefined,
  distanceUnitAfter: undefined,
  location: undefined,
  distanceMin: 0,
  distanceMax: 0,
  priceRangeMin: 0,
  priceRangeMax: 0,
  priceRangeSliderMin: 0,
  priceRangeSliderMax: 0,
  priceRangeStartIcon: undefined,
  priceRangeEndIcon: undefined,
  amenities: [],
  shouldInstantBook: false,
  showSeeMore: false,
  hideInstantBook: false,
  onClearButtonClick: () => {},
  onUpdateFiltersButtonClick: () => {},

  onInstantBookToggle: () => {},
  onAmenityClick: () => {},
  onSeeMoreClick: () => {},
  onPriceRangeChangeSlider: () => {},
  onPriceRangeChangeInput: () => {},
  onDistanceChangeSlider: () => {},
  onDistanceChangeInput: () => {},
  onPropertyClick: () => {},
  distanceProps: undefined
};
